export default __webpack_public_path__ + "static/media/amiens6.aff092a2.jpg";